import { Box, Stack } from '@mui/material';
import { Divider, Text } from '@telegram-apps/telegram-ui';
import dayjs from 'dayjs';
import { FC } from 'react';
import { ListGoal } from '../../client/types';
import { useWeeklyGoalProgress } from '../../hooks/useWeeklyGoalProgress';

type WeekProgressProps = {
  goal: ListGoal;
  goalCompletion: string;
};

export const WeekProgress: FC<WeekProgressProps> = ({ goal, goalCompletion }) => {
  const statsMap = useWeeklyGoalProgress([goal], goalCompletion);
  if (!statsMap) return null;
  const stats = statsMap[goal.id];
  const end = dayjs(goalCompletion);
  const start = end.subtract(1, 'week');
  const dayDates = Array.from({ length: 7 }, (_, i) => start.add(i, 'day'));
  return (
    <Stack direction="row" spacing={1} alignItems="flex-end" justifyContent="space-between" width="100%">
      {stats.map((dayStat, idx) => {
        const date = dayDates[idx];
        const isToday = dayjs().isSame(date, 'day');
        const { xpForDay, targetForDay } = dayStat;
        const borderColor =
          xpForDay >= targetForDay
            ? 'var(--tgui--button_color)'
            : xpForDay > 0
            ? 'orange'
            : 'var(--tgui--hint_color)';
        return (
            <Stack key={idx} direction="column" spacing={0.5} alignItems="center">
                <Text style={{ fontSize: '12px', fontWeight: isToday ? 'bold' : 'normal' }}>
                    {date.format('ddd')}
                </Text>
                <Box
                    key={idx}
                    sx={{
                    border: isToday ? `3px solid ${borderColor}` : `1px solid ${borderColor}`,
                    borderRadius: '4px',
                    padding: '4px',
                    width: '32px',
                    textAlign: 'center',
                    }}
                >
                    <Text style={{ fontSize: '12px', }}>{xpForDay}</Text>
                    <Divider style={{ width: '100%' }} />
                    <Text style={{ fontSize: '12px' }}>{targetForDay}</Text>
                </Box>
            </Stack>
        );
      })}
    </Stack>
  );
}; 